import { createContext } from 'react';

export const OneTimePaymentContext = createContext();
